import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const { REACT_APP_MODE, REACT_APP_REQ_DEV_API, REACT_APP_REQ_PROD_API, REACT_APP_REVERB_APP_KEY, REACT_APP_REVERB_HOST, REACT_APP_REVERB_PORT, REACT_APP_REVERB_SCHEME } = process.env;
const ENDPOINT_API = REACT_APP_MODE === 'dev' ? REACT_APP_REQ_DEV_API : REACT_APP_REQ_PROD_API;

window.Pusher = Pusher;

const EchoInstance = new Echo({
  broadcaster: 'reverb',
  key: REACT_APP_REVERB_APP_KEY,
  wsHost: REACT_APP_REVERB_HOST,
  wsPort: REACT_APP_REVERB_PORT,
  wssPort: REACT_APP_REVERB_PORT,
  forceTLS: (REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  authEndpoint: `${ENDPOINT_API}broadcasting/auth`,
});

export default EchoInstance;
